import React from "react";
import "./ConfigPane.scss";
import "../JSONHTML.css";
import ConfigPaneFormRow from "./ConfigPaneFormRow";
import { JSON2HTML, pathArray2Val } from "../../../../helpers/JSONParser";
import { unescapeHTML } from "../../../../helpers/unescapeHTML";
import { sensorPropNames2Labels } from "../../../../helpers/constants";

import PalamButton from "../../../generic/palam_button";

import { withTranslation } from 'react-i18next';


class DeviceSensorConfigPane extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      txt: "",
      JSONPreviewIdx: 0,
      focusedInput: -1,
      showTransformRows: false
    };
  }

  componentDidMount() {
    let pre = document.getElementById("jsonpre");
    pre.addEventListener("click", this.onJSONPropClick.bind(this));
  }

  onJSONPropClick(evt) {
    let { device, requestSetDeviceSensorDataValue, sensorIdx } = this.props;

    if (!evt.target.classList || evt.target.classList[0] !== "jsh-val") {
      return;
    }
    console.log(
      "clicked JSON prop",
      evt.target.innerText,
      "path:",
      evt.target.dataset.path
    );

    let currentKey = Object.keys(device.sensorConfig[sensorIdx])[
      this.state.focusedInput
    ];
    if (!currentKey) {
      return;
    }
    requestSetDeviceSensorDataValue(
      device.uid,
      sensorIdx,
      currentKey,
      evt.target.dataset.path,
      "JSON"
    );
    this.onInputFocus(-1);
  }

  onStepJSONPreview(incr) {
    let JSONLength = this.props.device.rawJSONS.length;
    let currentIdx = this.state.JSONPreviewIdx;
    let newIdx;
    console.log("777", currentIdx, JSONLength);
    if (currentIdx >= JSONLength - 1 && incr) {
      newIdx = 0;
    } else if (currentIdx === 0 && !incr) {
      newIdx = JSONLength - 1;
    } else {
      newIdx = incr ? currentIdx + 1 : currentIdx - 1;
    }
    this.setState({ JSONPreviewIdx: newIdx });
  }

  onInputFocus(idx) {
    console.log("oninputfocus", idx);
    this.setState({ focusedInput: idx });
  }

  onManualEdit(evt) {
    console.log("evt", evt);
    let { device, setDeviceSensorDataValue, sensorIdx } = this.props;
    let currentKey = Object.keys(device.sensorConfig[sensorIdx])[
      this.state.focusedInput
    ];
    if (!currentKey) {
      return;
    }
    //Clear input on transition JSON->Manual
    let wasJSON = device.sensorConfig[sensorIdx][currentKey].method === "JSON";
    console.log("manual edit", wasJSON);
    if (wasJSON) {
      setDeviceSensorDataValue(device.uid, sensorIdx, currentKey, "", "manual");
    } else {
      setDeviceSensorDataValue(
        device.uid,
        sensorIdx,
        currentKey,
        evt.target.value,
        "manual"
      );
    }
  }

  onBlur(evt) {
    let { device, requestSetDeviceSensorDataValue, sensorIdx } = this.props;

    let currentKey = Object.keys(device.sensorConfig[sensorIdx])[
      this.state.focusedInput
    ];

    if (evt.target.value !== "") {
      requestSetDeviceSensorDataValue(
        device.uid,
        sensorIdx,
        currentKey,
        evt.target.value,
        "manual"
      );
    }

    this.onInputFocus(-1);
  }

  onClear() {
    console.log("onClear");
    let { device, requestSetDeviceSensorDataValue, sensorIdx } = this.props;
    let currentKey = Object.keys(device.sensorConfig[sensorIdx])[
      this.state.focusedInput
    ];
    if (!currentKey) {
      return;
    }
    requestSetDeviceSensorDataValue(
      device.uid,
      sensorIdx,
      currentKey,
      "",
      undefined
    );
  }

  onResetJSONState() {
    let { device } = this.props;
    this.props.requestResetJSONState(device.uid);
  }

  toggleTransforms() {
    console.log("toggle transforms");
    this.setState({ showTransformRows: !this.state.showTransformRows });
  }

  renderFormRows(sensorConfig, rawJSON) {
    let {t} = this.props;
    let labels = Object.keys(sensorConfig);
    let els = labels.map((label, idx) => {
      // console.log("label", label)
      if (!label || label === "undefined") {
        return null;
      }
      let isColor = label === "color";
      let isValue = label === "value";
      let isTransformRow = label === "value_factor" || label === "value_offset";
      if (isTransformRow && !this.state.showTransformRows) {
        return null;
      }

      // TODO: this may be confusing. before the following line 'label is actually' the key of
      // the value, thats later called label
      label = sensorPropNames2Labels[label];
      // If the method is JSON, send the extracted value from the currently selected JSON, instead of the path
      let value = sensorConfig[Object.keys(sensorConfig)[idx]].value;
      let method = sensorConfig[Object.keys(sensorConfig)[idx]].method;
      if (method === "JSON") {
        let path = value;
        // Path is an array of keys/idxs
        //value = rawJSON[JSON.parse(path)];
        value = unescapeHTML(pathArray2Val(path, rawJSON, t("json_noval")));
      }

      // Transform
      let transformedValue;
      if (isValue && this.state.showTransformRows) {
        let transform_factor = 1;
        let transform_offset = 0;
        try {
          let factor = parseFloat(sensorConfig["value_factor"].value);
          console.log("444", factor);
          if (!isNaN(factor)) {
            transform_factor = factor;
          }
        } catch (error) {
          console.error("Could not get value_factor");
        }
        try {
          let offset = parseFloat(sensorConfig["value_offset"].value);
          if (!isNaN(offset)) {
            transform_offset = offset;
          }
        } catch (error) {
          console.error("Could not get value_offset");
        }
        transformedValue = value;
        try {
          transformedValue =
            parseFloat(value) * transform_factor + transform_offset;
        } catch (error) {}
      }
      //

      return (
        <ConfigPaneFormRow
          label={t(label)}
          value={value}
          transformedValue={
            isValue && this.state.showTransformRows
              ? transformedValue
              : undefined
          }
          isTransformRow={isTransformRow}
          isColor={isColor}
          isValue={isValue}
          method={sensorConfig[Object.keys(sensorConfig)[idx]].method}
          key={idx}
          isFocused={this.state.focusedInput === idx}
          onFocus={() => {
            this.onInputFocus(idx);
          }}
          onBlur={this.onBlur.bind(this)}
          onManualEdit={this.onManualEdit.bind(this)}
          onClear={this.onClear.bind(this)}
          toggleTransforms={this.toggleTransforms.bind(this)}
        />
      );
    });
    return els;
  }

  render() {
    let { device, sensorIdx, t } = this.props;
    let { rawJSON } = device;
    let json = JSON.stringify(rawJSON) || "{}";

    let html = JSON2HTML(json);
    return (
      <div className="configpane-inner">
        <div className="configpane-container">
          <div className="configpane-form">
            {/* One dummy row as legend */}
            <ConfigPaneFormRow isLegend />
            {this.renderFormRows.bind(this)(
              device.sensorConfig[sensorIdx],
              rawJSON
            )}
          </div>

          <div className="configpane-code">
            <pre id="jsonpre" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>

        <div className="configpane-form">
        <span>Sensor ID: {sensorIdx}</span>
              <br/>
          <div className="centered flex between">
            <PalamButton
              extraClasses="warning"
              onClick={e => {
                if (
                  window.confirm(t("delete_sensor_prompt"))
                ) {
                  this.props.requestDeleteSensor(device.uid, sensorIdx);
                }
                //this.deleteItem(e);
              }}
            >
              {t("delete_sensor_label")}
            </PalamButton>
            <PalamButton onClick={this.onResetJSONState.bind(this)}>
              {t("reset_json_label")}
            </PalamButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DeviceSensorConfigPane);
